import {
    BACKEND,
    apiEndpoint,
} from '../utils/api';
import * as logger from '../utils/logger';

export async function uploadAttachment(file, uploadProgressCallback, abortController) {
    const backendAttachmentUploadEndpoint = apiEndpoint({
        api: BACKEND,
        endpoint: 'applications/attachment',
        options: {
            onUploadProgress(e) {
                const percentCompleted = Math.round((e.loaded * 100) / e.total);
                uploadProgressCallback(percentCompleted);
            },
            signal: abortController?.signal,
        },
        timeout: 120000,
    });

    return backendAttachmentUploadEndpoint.post('', file)
        .then(response => response.data)
        .catch((exception) => {
            logger.error({
                exception,
                fingerprint: ['Uploading attachment failed.'],
                message: 'Uploading attachment failed.',
                extra: {
                    attachment: file,
                    response: exception?.response?.data ?
                        JSON.stringify(exception.response.data) :
                        'No response available.',
                },
            });
            throw exception;
        });
}
